import { useDecodedAccessToken } from '@b-stock/fe-core/bstock-next/components'

/**
 * Returns an account ID that FE should submit when identifying the account
 * against which or as which actions should be taken. Returns null if the this
 * ID can not be determined (e.g. for unauth'd users)
 *
 * Currently returns the accountId identified in the access token. Will need
 * to account for path params which identify an acting account in the future.
 */
const useAccountId = (): string | null => {
  return useDecodedAccessToken()?.accountId ?? null
}

export default useAccountId
